export default __webpack_public_path__ + "static/media/hr-policies-and-practices.0e3b0cb1.pdf";